import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowUpOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m12.9 5.446 6.827 6.827L21 11l-9-9-9 9 1.273 1.273L11.1 5.446V22h1.8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowUpOutlinedSize24Glyph.displayName = 'ArrowUpOutlinedSize24Glyph';
